<template>
  <div>
    <section class="content">
      <div class="row center-block">
        <div class="box">
          <!-- Box Header -->
          <div class="box-header">
            <div class="row" align="center">
              <h3>API Testing</h3>
            </div>
          </div>

          <!-- Box Body -->
          <div class="box-body">
            <v-row>
              <v-col cols="6">
                <v-row>
                  <v-col cols="4">
                    <v-combobox v-model="method" :items="methods" outlined label="Select method"></v-combobox>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="url" label="URL" outlined placeholder="URL"></v-text-field>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <h3>Header options</h3>
                <v-row v-for="(header, index) in headers" :key="header.key">
                  <v-col cols="3">
                    <v-text-field
                      v-model="header.key"
                      outlined
                      hide-details
                      label="Name"
                      placeholder="Name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="header.value"
                      outlined
                      hide-details
                      label="Value"
                      placeholder="Value"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-btn class="ma-2" outlined color="red" @click="removeHeader(index)">Remove</v-btn>
                  </v-col>
                </v-row>
                <v-btn class="ma-2" outlined color="green" @click="addHeader()">Add</v-btn>
                <v-row>
                  <v-col>
                    <v-textarea v-model="body" outlined name="input-7-1" label="Body"></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn color="secondary" @click="testAPI">Send Request</v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <v-alert :type="response.type">{{response.text}}</v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      v-model="response.data"
                      outlined
                      name="input-7-1"
                      label="Response"
                      readonly
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'APITesting',
  data() {
    return {
      url: '',
      method: 'GET',
      methods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'],
      headers: [{ key: 'Content-Type', value: 'application/json' }],
      body: '',
      response: {
        type: '',
        text: '',
        data: ''
      }
    };
  },
  methods: {
    addHeader() {
      this.headers.push({ key: '', value: '' });
    },
    removeHeader(index) {
      this.headers.splice(index, 1);
    },
    async testAPI() {
      try {
        let headers = {};
        let hd = Object.assign([], this.headers);
        hd.forEach(element => {
          headers[element.key] = element.value;
        });
        let resp = await axios({
          method: this.method,
          url: this.url,
          headers,
          data: this.body
        });
        console.log(resp)
        this.response.type = 'success';
        this.response.text = 'Success';
        this.response.data = JSON.stringify(resp.data, null, 4);
      } catch (error) {
        this.response.type = 'error';
        this.response.text = 'Error';
        this.response.data = JSON.stringify(error);
      }
    }
  }
};
</script>

<style>
#email {
  height: 50px;
  border: 3px solid #3c8dbc;
  border-radius: 10px;
  text-align: center;
  font-size: medium;
  margin-top: 10px;
}

#email:focus {
  outline: none;
}

#check-btn {
  font-size: x-large;
  background: #3c8dbc;
  color: white;
  margin-top: 20px;
}
#create-btn {
  font-size: x-large;
  background: #3cbc58;
  color: white;
  margin-top: 20px;
}

#try_this_link {
  font-size: large;
}
</style>



// WEBPACK FOOTER //
// Testing.vue?a03dcdda